import React, { useState } from "react";
import { FiMenu, FiX } from "react-icons/fi";
import styled, { keyframes } from "styled-components";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { auth } from "./firebase";
import { collection, onSnapshot, query, orderBy } from "firebase/firestore";
import { db } from "./firebase";
import SearchIcon from "@mui/icons-material/Search";
import { useEffect } from "react";
import "./NavBarSearch.css";
import { Link, useNavigate } from "react-router-dom";
import { useStateValue } from "./StateProvider";
import ReactGA from "react-ga4";

const Nav = styled.nav`
  display: flex;
  justify-content: center;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  color: white;
  display: flex;
  padding: 1rem 10%;
  position: fixed;
  width: 100%;
  top: 0;
  transition: background 0.4s ease, padding 0.3s ease;
  background: ${({ scrolled }) =>
    scrolled ? "rgba(0, 0, 0, 0.85)" : "transparent"};
  box-shadow: ${({ scrolled }) =>
    scrolled ? "0 2px 10px rgba(0,0,0,0.2)" : "none"};
`;
const Logo = styled(Link)`
  font-size: 1.5rem;
  font-weight: bold;
  color: #8b0000;
  text-decoration: none;
  margin-top: -12px;
  margin-left: -25px;
`;
const NavLinks = styled.ul`
  display: flex;
  gap: 1rem;
  list-style: none;
  @media (max-width: 768px) {
    position: fixed;
    top: 5px;
    right: ${({ open }) => (open ? "0" : "-100%")};
    left: ${({ open }) => (open ? "0" : "-100%")};
    height: 50vh;
    width: 95%;
    // background: rgba(44, 6, 75, 0.93);
    background: rgba(137, 5, 19, 0.93);
    flex-direction: column;
    align-items: left;
    margin: 10px;
    margintop: 200px;
    padding: 50px;
    border-radius: 10px;
    justify-content: top;
    transition: right 0.3s ease-in-out;
    box-shadow: ${({ open }) => (open ? "-2px 0 8px rgba(0,0,0,0.2)" : "none")};
  }
`;
const NavItem = styled(Link)`
  @media (max-width: 768px) {
  color: #e4d3d3ff;
  text-decoration: none;
  font-weight: 500;
  &:hover {
    color: #858639ff;
  }
`;
const MenuIcon = styled.div`
  display: none;
  font-size: 1.8rem;
  cursor: pointer;
  @media (max-width: 768px) {
    color: #f5f5f1ff;
    margin-right: 5px;
    display: block;
    z-index: 100; // makes sure the close button dont hide
    transition: transform 0.3s ease-in-out;
    transform: ${({ open }) => (open ? "translateX(0)" : "translateX(-1%)")};
  }
`;
const StyledHr = styled.hr`
  max-width: 60px;
  @media (max-width: 768px) {
    color: black;
    border: none; /* Reset default border */
    border-top: 0.1px solid #5b4d4dff; /* Add a custom top border */
    width: 100%; /* Adjust width */
    max-width: 600px; /* Set a maximum width */
    align-self: center; /* Center the HR if it's within a flex or grid container */
  }
`;
const StyleSubMenudHr = styled.hr`
  color: black;
  padding-top: 10px;
  padding-bottom: 10px;
  border: none; /* Reset default border */
  border-top: 0.1px solid #734747ff; /* Add a custom top border */
  width: 70%; /* Adjust width */
  max-width: 600px; /* Set a maximum width */
  align-self: center; /* Center the HR if it's within a flex or grid container */
`;
const SubMenu = styled.div`
  margin-left: 15px;
  margin-top: 5px;
  display: ${({ open }) => (open ? "block" : "none")};
  margin-left: 10px;
  max-height: ${({ open }) => (open ? "300px" : "0")};
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
`;
const SubItem = styled(Link)`
  padding-top: 20px;
  padding-bottom: 20px;
  font-size: 0.9rem;
  color: #e4d3d3ff;
  text-decoration: none;
  font-weight: 500;
  &:hover {
    color: #fffcfcff;
  }
`;
const StyleFiChevronRight = styled.div`
  position: absolute;
  right: 55px;
  color: #ddd;
  cursor: pointer;
`;

const StyledItemCheveronContainer = styled.div`
 display: "flex",
flexDirection: "row",
alignItems: "center",
`;

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSub, setActiveSub] = useState(null);
  const [input, setInput] = useState("");
  const [results, setResults] = useState([]);
  let entry = "";
  const [products, setProducts] = useState([]);
  const [{ basket, user }, dispatch] = useStateValue();
  const navigate = useNavigate();
  ReactGA.initialize("G-YHX58MM6Z9");
  const toggleSubMenu = (index) => {
    setActiveSub(activeSub === index ? null : index);
  };
  const gradientAnimation = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

  const searchIcon = styled.div`
    color: violet;
    height: 25px;
    width: 25px;
    position: relative;
  `;
  const GradientAnimator = styled.div`
    width: 100%;
    font-family: Didot, serif;
    font-weight: bold;
    line-height: 0.95;
    border: none;
    border-radius: 12px;
    cursor: pointer;
    background: none;
    color: transparent;
        background-image: linear-gradient(
      90deg,
   
   
    #f5a8a7ff,
      #fbf8faff,
         #fbf8faff,
          #fbf8faff,
           #fbf8faff,
    #fbf8faff,
     #f5a8a7ff,
     #fbf8faff,
   #fbf8faff,
    #fbf8faff,
     #fbf8faff,
     #f5a8a7ff
    ); 
 
    background-size: 900% 900%;
    background-clip: text;
    -webkit-background-clip: text;
    animation: ${gradientAnimation} 15s ease infinite;

    &:hover {
      transform: scale(1.05);
    }

    h1 {
      font-size: 85px;
      @media (max-width: 768px) {
        font-size: 2.5rem;
      }
    }
     h2 {  
      @media (max-width: 768px) {
       padding-bottom:0px;
      }
  `;
  React.useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/Home", title: "Header Title" });
    const data = JSON.parse(localStorage.getItem("dls-basket"));
    if (data) {
      dispatch({
        type: "REFRESH_BASKET",
        item: data,
      });
    }
  }, []);
  //
  React.useEffect(() => {
    if (basket.length >= 1) {
      localStorage.setItem("dls-basket", JSON.stringify([...basket]));
    } else {
      localStorage.removeItem("dls-basket");
    }
    ReactGA.event({
      category: "Basket category",
      action: `${basket.length} item(s) added to basket by ${user}`,
      label: "Basket label",
      value: 99,
      nonInteraction: true,
      transport: "xhr",
    });
  }, [basket]);
  //.  CHECK IF PRODUCT TABLE HAS CONTENT. IF NO BASKET MUST BE O
  //   ----  THIS OPTIMIZES THE SITUATION OF DELETING PROD TABLE FROM BACKEND,
  //   ------ WHEN BASKET HAS CONTENT

  useEffect(() => {
    const dbRef = collection(db, "ProductTable");
    const q = query(dbRef, orderBy("createdAt", "asc"));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      setProducts(
        querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
      );
    });
    return unsubscribe;
  }, []);
  const fetchData = (value) => {
    try {
      entry = value;
      const results = products.filter((item) => {
        return (
          entry &&
          item &&
          item.description1 &&
          item.description1.toLowerCase().includes(entry.toLowerCase())
        );
      });
      setResults(results);
    } catch (er) {
      alert.show("Something went wrong !");
    }
  };
  const handleChange = (value) => {
    setInput(value);
    fetchData(value);
  };
  const handleAuthentication = (e) => {
    e.preventDefault();
    if (user) {
      auth.signOut();
      navigate("/Home");
    }
    setOpen(false);
  };
  const handleBecomeASeller = (e) => {
    e.preventDefault();
    if (user) {
      navigate("/CompanyOnboardin");
    }
    setOpen(false);
  };
  return (
    <Nav
      style={{
        backgroundColor: "#050d25ff",
      }}
    >
      <span className="SearchColumnItems">
        <GradientAnimator>
          <p>
            <h3>Christmas Promos !</h3>
          </p>
        </GradientAnimator>
        <span className="header_search">
          <input
            value={input}
            onChange={(e) => handleChange(e.target.value)}
            className="header_searchInput"
            placeholder="search  ..."
            type="text"
          />
          <span className="header_searchIcon " onClick={null}>
            <div className="searchIcon">
              <SearchIcon />
            </div>
          </span>
        </span>
        {/* <h6 color="white">Electronics | Home use | General </h6> */}

        <h6> All Categories | Electronics </h6>
      </span>
      <span className="header_Shop_basket">
        <Link to="Checkout" style={{ textDecoration: "none" }}>
          <div className="header_option">
            <span className="header_optionLineTwo header_basketCount">
              {basket?.length}
            </span>
            <span>
              <ShoppingCartOutlinedIcon
                sx={{ marginLeft: 0, padding: 0, color: "white" }}
              />
            </span>
            {/* // the auth user is not null display Sign Out  : */}
            {/*  ?. optional chaining is to skip any errors, eg due to null value     */}
          </div>
        </Link>
        <Link
          style={{
            textDecoration: "none",
            color: "white",
            fontSize: "18px",
            marginLeft: 30,
          }}
          to="/Home"
        >
          <GradientAnimator>
            <p>
              <h4> Shop </h4>
            </p>
          </GradientAnimator>
        </Link>
      </span>
      <MenuIcon onClick={() => setOpen(!open)}>
        {open ? <FiX /> : <FiMenu />}
      </MenuIcon>
      <NavLinks open={open}>
        <li>
          <NavItem to="/" onClick={() => setOpen(false)}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                color: "white",
              }}
            >
              Home
              <br /> <br />
            </div>
          </NavItem>
        </li>

        <li>
          <NavItem to="/Login" onClick={() => setOpen(false)}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                color: "white",
              }}
            >
              Login <br /> <br />
            </div>
          </NavItem>
        </li>

        <li>
          <NavItem to="/" onClick={() => setOpen(false)}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                color: "white",
              }}
            >
              Orders <br /> <br />
            </div>
          </NavItem>
        </li>
        <li>
          <NavItem to="/emailForm2" onClick={() => setOpen(false)}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                color: "white",
              }}
            >
              Help
            </div>
          </NavItem>
        </li>
        <li>
          <NavItem to="/" onClick={handleAuthentication}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                color: "white",
              }}
            >
              Logout
            </div>
          </NavItem>
        </li>
        <li>
          <NavItem to="/CompanyOnboardin" onClick={() => setOpen(false)}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                color: "white",
              }}
            >
              Become a seller
            </div>
          </NavItem>
        </li>
      </NavLinks>
    </Nav>
  );
};

export default Navbar;

// SSTYLED COMPONENTS. :
